import styled from "styled-components";

const Input = styled.input.attrs({
    type: "text",
})<{
    enableDarkTheme?: boolean;
    textAlign: string;
}>`
    pointer-events: all;
    outline: none;
    direction: ltr;
    text-align: ${(p) => p.textAlign};
    margin: 0 0 3px 0;
    border: 0;
    width: ${(p) => p.width}px;
    height: 30px;
    line-height: 30px;
    font-family: "Source Code Pro", monospace;
    border-bottom: 1px solid ${(p) => (p.enableDarkTheme ? "#000" : "#fff")};
    color: ${(p) => (p.enableDarkTheme ? "#000" : "#fff")};
    background-color: transparent;
    font-size: 14px;

    &::placeholder {
        direction: rtl;
        font-family: urdu;
        font-weight: 500;
        color: ${(p) => (p.enableDarkTheme ? "#333" : "#e6e6e6")};
    }
`;

type Props = {
    width: number | string;
    value: number;
    textAlign?: string;
    enableDarkTheme?: boolean;
    placeholder: string;
    onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyUp: (evt: React.KeyboardEvent<HTMLInputElement>) => void;
    attachRef?: React.RefObject<HTMLInputElement>;
};

export default function TextField({
    width,
    value,
    textAlign,
    enableDarkTheme,
    placeholder,
    onChange,
    onKeyUp,
    attachRef,
}: Props) {
    return (
        <Input
            ref={attachRef}
            width={width}
            value={value}
            textAlign={textAlign || "right"}
            enableDarkTheme={enableDarkTheme}
            placeholder={placeholder}
            onChange={onChange}
            onKeyUp={onKeyUp}
        />
    );
}
